import React from 'react'
import PropTypes from 'prop-types'
import MultiSelectPicker from '../MultiSelectPicker'
import { CONTENT_FILTER_OPTIONS, filterTriggerLabel } from './constants'

const formatSelectedLabel = count =>
  filterTriggerLabel('Type de contenu', count, CONTENT_FILTER_OPTIONS.length)

const ContentFilter = ({ value, onChange }) => (
  <MultiSelectPicker
    formatSelectedLabel={formatSelectedLabel}
    options={CONTENT_FILTER_OPTIONS}
    placeholder="Type de contenu"
    searchable={false}
    selectedValues={value}
    onChange={onChange}
  />
)

ContentFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default ContentFilter
